import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  cooperativeName: {
    marginRight: 10,
    fontSize: 16,
    fontWeight: 600,
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  icon: {
    fontSize: '1.3rem',
    color: '#fff',
  },
  pointer: {
    maxHeight: '50vh',
    overflow: 'hidden',
    overflowY: 'auto',
    padding: '15px 0',
    cursor: 'pointer',
  },
}));
